import { registerTranslationForMts, registerTranslationForTiposBoth } from 'easit--localization';
import { enGbForMts } from '../localization/translationEnMts';
import { csCzForMts } from '../localization/translationCzMts';
import { skSkMts } from '../localization/translationSkSkMts';
import { lvLVForMts } from '../localization/translationLvMts';
import { ruRuForMts } from '../localization/translationRuMts';
import { skSkForTiposBoth } from '../localization/translationTiposBothSkSk';
import { skSkMtsTipos } from '../localization/translationSkSkMtsTipos';

export function registerTranslationsForMts(): void {

    if (__IsMTSTipos__) {
        registerTranslationForMts('sk', skSkMtsTipos);
    } else {
        registerTranslationForMts('sk', skSkMts);
        registerTranslationForMts('en', enGbForMts);
        registerTranslationForMts('cs', csCzForMts);
        registerTranslationForMts('lv', lvLVForMts);
        registerTranslationForMts('ru', ruRuForMts);
    }
}

export function registerTranslationsForTiposBoth(): void {
    registerTranslationForTiposBoth('sk', skSkForTiposBoth)
}

